import { Injectable } from '@angular/core';
import { HttpUtils } from '../../http/HttpUtils';
import { BuilderSaveApiRequest } from './Models/BuilderSaveApiRequest';

@Injectable({
    providedIn: 'root'
})

export class BuilderSaveApi
{
    private apiUrl = '/api/builder/save';

    public async ExecuteAsync(request: BuilderSaveApiRequest): Promise<void>
    {
        const response = await fetch(`${this.apiUrl}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
        });

        await HttpUtils.ProcessFetchResultAsync(response);
    }
}
